import { SearchTrackingData, StringService, useComponentTracking, useTranslation } from '@repo/roche-xx-shared';
import {
  RocheUIStoryTeaser,
  RocheUIStoryTeaserLayout,
  RocheUITeaser,
  RocheUITeaserLayout,
} from '@rocheglobal/roche-ui';
import React from 'react';
import { trackSearchItemClickEvent } from '../tracking';
import { RocheSearchResultItem, SearchCategory } from './queries';

export interface SearchItemProps {
  item: RocheSearchResultItem;
  tab: SearchCategory;
  trackingData: SearchTrackingData;
}
export const MainSearchItem = ({ item, tab, trackingData }: SearchItemProps) => {
  const { path } = useComponentTracking();
  const tagLabel = item.teaserType ? StringService.capitalize(useTranslation(item.teaserType)) : undefined;

  const trackItemClick = (e) => trackSearchItemClickEvent(e, trackingData, item.title, item.url, path);

  switch (tab) {
    case SearchCategory.PAGES:
      return (
        <RocheUITeaser
          layout={RocheUITeaserLayout.VARIANT_A_WITHOUT_IMAGE}
          isDownloadLink={false}
          isSearchResult={true}
          teaserTitle={item.title}
          teaserDescription={item.description}
          teaserImage={item.image}
          teaserImageAlt={item.title}
          teaserOverline={item.publishedDate}
          teaserUrl={item.url}
          teaser-date={item.publishedDate}
          onTeaserClick={trackItemClick}
        />
      );
    case SearchCategory.STORIES:
      return (
        <RocheUIStoryTeaser
          slot='teasers'
          teaserType={item.teaserType}
          teaserTagLabel={tagLabel}
          layout={RocheUIStoryTeaserLayout.VARIANT_A}
          teaserTitle={item.title}
          teaserDescription={item.description}
          teaserDate={item.formattedReleaseDate}
          dateTimeValue={item.publishedDate}
          teaserImage={item.image!}
          teaserImageAlt={item.title}
          teaserUrl={item.url}
          onTeaserLinkClick={trackItemClick}
        />
      );
    case SearchCategory.DOCUMENTS:
      return (
        <RocheUITeaser
          teaser-type={'documents'}
          teaserTitle={item.title}
          teaserDescription={item.description}
          teaserUrl={item.url}
          layout={RocheUITeaserLayout.VARIANT_A_WITHOUT_IMAGE}
          isDownloadLink={true}
          isSearchResult={false}
          onTeaserClick={trackItemClick}
        />
      );
    default:
      return null;
  }
};
